import React from "react";

export default function FormSubmitted() {
  return (
    <div>
      <h2>Form Submitted</h2>
      <p>Your request was proccesed. Our team will get back to you ASAP.</p>
    </div>
  );
}
